
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        total: {
            type: Number,
            default: 0
        },
        crew: {
            type: Number,
            default: 0
        },
        cargo: {
            type: Number,
            default: 0
        }
    }
})
